import {
  MP_CHANGE_CURRENT_PROJECT_PAGE,
  MP_PROJECT_LAUNCH_LIST,
  MP_SEARCH_JOBS,
  MP_SET_PROJECT_ITEMS_PER_PAGE,
  MP_PROJECT_STATUS_FILTER,
  MP_LAUNCH_NOTES_LOADER,
  MP_LAUNCH_NOTES_LIST_SUCCESS,
  MP_LAUNCH_NOTES_LIST_FAIL,
  MP_LAUNCH_OFFER_LIST_SUCCESS,
  MP_LAUNCH_OFFER_LOADER,
  MP_RENEWAL_LOADER,
  MP_RENEWAL_LIST_SUCCESS,
  MP_RENEWAL_LIST_FAIL,
  MP_FINANCE_LOADER,
  MP_FINANCE_LIST_SUCCESS,
  MP_FINANCE_LIST_FAIL,
  MP_LAUNCH_DETAILS,
  CHANGE_MP_LAUNCH_TAB,
  SET_MP_LAUNCH_DATE_FILTER,
  CLEAR_MP_LAUNCH_DATE_FILTER,
  BULK_UPLOAD_PAYMENTS,
  VIEW_AGREEMENT,
  SET_AGREEMENT_TYPE,
  MP_SEARCH_OFFERS,
  COMPANY_LEGAL_INFO,
  GET_COUNTRY_LIST,
  CONSULTANT_LEGAL_INFO,
  CUSTOM_CLIENT_LEGAL_INFO,
  GET_BILLING_CONFIG,
} from "../actions/mpLaunchesAction";

const initialState = {
  mpLaunchListing: [],
  mpLaunchTotalResults: null,
  mpLaunchTotalPages: null,
  mpLaunchPageIds: [],
  fetchingData: true,
  mpLaunchSearchText: "",
  mpLaunchCurrentPage: 1,
  mpLaunchListResultPerPage: 10,
  mpLaunchStatusFliter: [],
  notesList: [],
  notesLoading: false,
  offerList: [],
  offersCurrentPage: 1,
  offersListResultPerPage: 10,
  offersTotalResults: null,
  offersTotalPages: null,
  offersPageIds: [],
  offersSearchText: "",
  offersLoading: false,
  renewalsList: [],
  renewalsLoading: false,
  paymentsList: [],
  paymentsLoading: false,
  launchDetails: null,
  initialTab: 0,
  tabValues: {},
  dateFilters: {
    launch_date: null,
    latest_start_date: null,
    termination_date: null,
    tentative_end_date: null,
  },
  bulkPayments: null,
  viewAgreement: [],
  agreement: "",
  countryList: [],
  billingConfig:[]
};

const mpLaunchesReducer = (state = initialState, action) => {
  switch (action.type) {
    case MP_PROJECT_LAUNCH_LIST: {
      return {
        ...state,
        mpLaunchListing: action.payload.results,
        mpLaunchTotalResults: action.payload.total_results,
        mpLaunchTotalPages: action.payload.total_pages,
        mpLaunchPageIds: action.payload.page_ids,
        fetchingData: false,
      };
    }

    case MP_CHANGE_CURRENT_PROJECT_PAGE: {
      return {
        ...state,
        mpLaunchCurrentPage: action.payload,
      };
    }

    case MP_SET_PROJECT_ITEMS_PER_PAGE: {
      return {
        ...state,
        mpLaunchListResultPerPage: action.payload,
      };
    }
    case MP_SEARCH_JOBS: {
      return {
        ...state,
        mpLaunchSearchText: action.payload,
      };
    }

    case MP_PROJECT_STATUS_FILTER: {
      return {
        ...state,
        mpLaunchStatusFliter: action?.payload || [],
      };
    }
    case MP_LAUNCH_NOTES_LOADER:
      return { ...state, notesLoading: true };
    case MP_LAUNCH_NOTES_LIST_SUCCESS:
      return { ...state, notesList: action.payload, notesLoading: false };
    case MP_LAUNCH_NOTES_LIST_FAIL:
      return { ...state, notesList: [], notesLoading: false };

    case MP_LAUNCH_OFFER_LIST_SUCCESS:
      return {
        ...state,
        offerList: action.payload.results,
        offersTotalResults: action.payload.total_results,
        offersTotalPages: action.payload.total_pages,
        offersPageIds: action.payload.page_ids,
        fetchingData: false,
      };

    case MP_LAUNCH_OFFER_LOADER:
      return { ...state, offersLoading: true };
    case MP_RENEWAL_LIST_SUCCESS:
      return { ...state, renewalsList: action.payload, renewalsLoading: false };
    case MP_RENEWAL_LIST_FAIL:
      return { ...state, renewalsList: [], renewalsLoading: false };
    case MP_RENEWAL_LOADER:
      return { ...state, renewalsLoading: true };
    case MP_FINANCE_LIST_SUCCESS:
      return { ...state, paymentsList: action.payload, paymentsLoading: false };
    case MP_FINANCE_LIST_FAIL:
      return { ...state, paymentsList: [], paymentsLoading: false };
    case MP_FINANCE_LOADER:
      return { ...state, paymentsLoading: true };
    case MP_LAUNCH_DETAILS: {
      return {
        ...state,
        launchDetails: action.payload,
      };
    }
    case CHANGE_MP_LAUNCH_TAB:
      return {
        ...state,
        initialTab: action.payload,
      };
    case SET_MP_LAUNCH_DATE_FILTER:
      return {
        ...state,
        dateFilters: {
          ...state.dateFilters,
          [action.payload.key]: action.payload.range,
        },
        mpLaunchCurrentPage: 1,
      };

    case CLEAR_MP_LAUNCH_DATE_FILTER:
      return {
        ...state,
        dateFilters: {
          ...state.dateFilters,
          [action.payload]: null,
        },
        mpLaunchCurrentPage: 1,
      };
    case BULK_UPLOAD_PAYMENTS: {
      return {
        ...state,
        bulkPayments: action.payload,
      };
    }

    case VIEW_AGREEMENT: {
      return {
        ...state,
        viewAgreement: Array.isArray(action.payload)
          ? action.payload
          : [action.payload],
      };
    }

    case SET_AGREEMENT_TYPE:
      return {
        ...state,
        agreementType: action.payload,
      };
    case MP_SEARCH_OFFERS: {
      return {
        ...state,
        offersSearchText: action.payload,
      };
    }

    case COMPANY_LEGAL_INFO:
      return {
        ...state,
        legalInfo: action.payload,
      };
    case CONSULTANT_LEGAL_INFO:
      return {
        ...state,
        consultantLegalInfo: action.payload,
      };
       case CUSTOM_CLIENT_LEGAL_INFO:
      return {
        ...state,
        customLegalInfo: action.payload,
      };
    case GET_COUNTRY_LIST:
      return {
        ...state,
        countryList: action.payload,
      };
     case GET_BILLING_CONFIG:
      return {
        ...state,
        billingConfig: action.payload,
      };
    default:
      return state;
  }
};

export default mpLaunchesReducer;
